// UI translations for CS (default), EN, DE.
// Vehicle-specific text (equipment, fuel, etc.) is localized in data/vehicles.js.

export const translations = {
  cs: {
    // Nav
    "nav.home": "Domů",
    "nav.offer": "Co nabízíme",
    "nav.how": "Jak to funguje",
    "nav.why": "Proč my",
    "nav.vehicles": "Vozy",
    "nav.forWhom": "Pro koho",
    "nav.partnership": "Partnerství",
    "nav.contact": "Poptávka",
    "cta.inquiry": "Nezávazná poptávka",

    // Hero
    "hero.subtitle": "Dlouhodobý pronájem vozidel bez kompromisů",
    "hero.line1": "Moderní řešení mobility pro jednotlivce i firmy.",
    "hero.line2": "Rychlé schválení, férové podmínky a vozy připravené k okamžitému využití.",
    "hero.ctaHow": "Jak to funguje",

    // Offer
    "offer.eyebrow": "Co nabízíme",
    "offer.title": "Co nabízíme",
    "offer.p1": "Poskytujeme dlouhodobý pronájem vozidel s důrazem na jednoduchost, rychlost a individuální přístup.",
    "offer.p2": "Naším cílem je zajistit vám spolehlivý vůz bez zbytečné administrativy a zdlouhavých procesů.",

    // How it works
    "how.eyebrow": "Jak to funguje",
    "how.title": "Jak to funguje",
    "how.step1Title": "Sdělíte nám své požadavky",
    "how.step1Desc": "Popište nám vaše potřeby",
    "how.step2Title": "Připravíme nabídku",
    "how.step2Desc": "Vybereme vhodná vozidla",
    "how.step3Title": "Vyberete a odjíždíte",
    "how.step3Desc": "Rychle a bez papírování",
    "how.footer1": "Bez složitého papírování.",
    "how.footer2": "Bez zbytečného čekání.",

    // Why us
    "why.eyebrow": "Proč EffectDeal",
    "why.title": "Proč právě EffectDeal",
    "why.individual": "Individuální přístup",
    "why.fast": "Rychlé vyřízení",
    "why.wide": "Široká nabídka vozidel",
    "why.flexible": "Flexibilní podmínky",
    "why.prices": "Výhodné ceny",

    // Vehicles gallery
    "vehicles.eyebrow": "Naše vozy",
    "vehicles.title": "Naše vozy",
    "vehicles.subtitle": "Vyberte konkrétní vůz. Najetím na náhledové fotky si auto prohlédnete ze všech stran, kliknutím zobrazíte kompletní výbavu a detaily.",
    "vehicles.footer": "Všechna vozidla jsou pravidelně servisovaná a připravená k okamžitému provozu.",
    "vehicles.included": "vč. pojištění, servisu a dálniční známky · 3 500 km/měs · bez skrytých poplatků",
    "vehicles.termLabel": "Délka pronájmu",
    "vehicles.termHint": "Čím déle, tím výhodněji – od 6 měsíců sleva 2 %, od 12 měsíců 5 %.",
    "vehicles.month1": "1 měsíc",
    "vehicles.monthsN": "měsíců",
    "vehicles.atTerm": "při",
    "vehicles.seats": "míst",
    "vehicles.googleTrust": "5,0 na Googlu · 14 recenzí",
    "detail.allPhotos": "Všechny fotky",
    "detail.photoOf": "z",
    "detail.specSeats": "Počet míst",
    "detail.specPower": "Výkon",
    "detail.specTrim": "Výbava",
    "detail.includedTitle": "V ceně máte",
    "detail.inc1": "Havarijní pojištění i povinné ručení",
    "detail.inc2": "Servis, údržba a sezónní pneu",
    "detail.inc3": "Dálniční známka ČR",
    "detail.inc4": "3 500 km měsíčně · žádné skryté poplatky",
    "detail.noDeposit": "Vratná kauce 10 000 Kč · bez dlouhého úvazku · od 1 měsíce",
    "compare.subtitle": "Férové srovnání: cena vedle ročníku, výkonu, nájezdu a výbavy – ať víte, co za peníze dostanete.",
    "compare.tabRentals": "Autopůjčovny",
    "compare.tabLeases": "Operativní leasing",
    "compare.rowPrice": "Cena / měsíc",
    "compare.rowYear": "Ročník",
    "compare.rowPower": "Výkon",
    "compare.rowMileage": "Nájezd",
    "compare.rowTrim": "Výbava / motor",
    "compare.rowTerm": "Úvazek",
    "compare.rowDeposit": "Akontace / kauce",
    "compare.rowKm": "Km v ceně",
    "compare.rowDiff": "Rozdíl oproti nám",
    "compare.ours": "Náš vůz",
    "compare.noTerm": "bez úvazku",
    "compare.noDeposit": "vratná kauce 10 000 Kč",
    "compare.kmOurs": "3 500 km/měs",
    "compare.avg": "průměr půjčoven",
    "compare.saveAvg": "Oproti průměru půjčoven ušetříte",
    "compare.pricier": "Jsme o",
    "compare.pricierTail": "dražší než průměr – ale za novější, výkonnější a lépe vybavený vůz bez úvazku, bez skrytých poplatků a jen s vratnou kaucí.",
    "compare.leaseHint": "Operák vypadá levněji, ale váže vás na 36–48 měsíců s akontací a pokutami za km navíc. U nás končíte, kdy chcete.",
    "compare.unknown": "—",
    "compare.whyTitle": "Co za cenu dostanete – rozdíl u každé nabídky",
    "compare.whyOlder": "starší ročník",
    "compare.whyNewer": "novější ročník",
    "compare.whyWeaker": "slabší motor",
    "compare.whyStronger": "silnější motor",
    "compare.whyTrim": "jiná výbava",
    "compare.whyTerm": "úvazek",
    "compare.whyDeposit": "akontace",
    "compare.whyKm": "méně km v ceně",
    "compare.whyCheaper": "levnější o",
    "compare.whyPricier": "dražší o",
    "compare.whySame": "stejná cena",
    "compare.whyNoDiff": "srovnatelná nabídka",
    "compare.whyOurs": "u nás",
    "why.p": "Dlouhodobý pronájem bez zbytečné administrativy. Vyberete auto, podepíšete online a jezdíte – pojištění, servis i dálniční známka jsou v ceně.",
    "why.forTitle": "Pro koho",
    "why.for": "Jednotlivci · OSVČ · firmy a flotily · kdokoliv, kdo chce auto hned a bez závazku",
    "vehicles.inStock": "Více kusů skladem",
    "vehicles.detail": "Detail",
    "vehicles.monthly": "Měsíční platba",
    "vehicles.showDetail": "Zobrazit detail",
    "vehicles.filterLabel": "Filtrovat podle typu",
    "vehicles.filterAll": "Všechny",
    "vehicles.available": "Volné ihned",
    "vehicles.onRequest": "Na dotaz",
    "vehicles.noResults": "Žádné vozy neodpovídají zvolenému filtru.",
    "vehicles.filterAvailable": "Volné ihned",
    "vehicles.sortLabel": "Řadit",
    "vehicles.sortDefault": "Doporučené",
    "vehicles.sortPriceAsc": "Cena: od nejnižší",
    "vehicles.sortPriceDesc": "Cena: od nejvyšší",
    "sticky.inquiry": "Nezávazná poptávka",
    "price.from": "od",
    "price.perMonth": "/ měsíc",
    "price.onRequest": "Cena na vyžádání",

    // Vehicle detail
    "detail.back": "Zpět na vozy",
    "detail.similarTitle": "Podobné vozy",
    "detail.similarAll": "Zobrazit všechny vozy",
    "detail.inStockModel": "Tento model máme skladem ve více kusech",
    "detail.monthly": "Měsíční platba",
    "detail.specYear": "Rok výroby",
    "detail.specTransmission": "Převodovka",
    "detail.specFuel": "Palivo",
    "detail.specMileage": "Najeto",
    "detail.inquiryBtn": "Mám zájem o tento vůz",
    "detail.call": "Zavolat",
    "detail.equipment": "Výbava vozu",
    "detail.interestedPre": "Zaujal vás",
    "detail.interestedDesc": "Ozvěte se nám a připravíme vám nezávaznou nabídku na míru.",
    "detail.bottomCta": "Nezávazná poptávka",
    "detail.notFoundTitle": "Vůz nenalezen",
    "detail.notFoundDesc": "Tento vůz již není v nabídce nebo odkaz není platný.",

    // Inquiry modal
    "modal.name": "Jméno a příjmení *",
    "modal.email": "E-mail *",
    "modal.phone": "Telefon *",
    "modal.duration": "Preferovaná délka pronájmu",
    "modal.durationPlaceholder": "Vyberte délku…",
    "modal.message": "Zpráva (nepovinné)",
    "modal.messagePlaceholder": "Máte dotaz nebo specifické přání?",
    "modal.submit": "Odeslat poptávku",
    "modal.submitting": "Odesílám…",
    "modal.note": "Odpovíme vám e-mailem co nejdříve",
    "modal.successTitle": "Poptávka odeslána!",
    "modal.successPre": "Děkujeme za zájem o",
    "modal.successPost": "Ozveme se vám co nejdříve.",
    "modal.ok": "Rozumím",
    "modal.error": "Něco se pokazilo. Zkuste to prosím znovu.",
    "dur.1-3": "1–3 měsíce",
    "dur.3-6": "3–6 měsíců",
    "dur.6-12": "6–12 měsíců",
    "dur.12+": "12+ měsíců",

    // For whom
    "forWhom.eyebrow": "Naši klienti",
    "forWhom.title": "Pro koho je služba",
    "promo.badge": "AKCE",
    "promo.originalPrice": "Běžná cena",
    "compare.title": "Srovnání s trhem",
    "compare.rental": "Běžná autopůjčovna",
    "compare.lease": "Operativní leasing",
    "compare.leaseNote": "úvazek 36–48 měsíců",
    "compare.usNote": "bez dlouhého úvazku",
    "compare.save": "U nás ušetříte až",
    "compare.mo": "Kč/měs",
    "compare.showAll": "Porovnat s konkurencí",
    "compare.hide": "Skrýt srovnání",
    "compare.rentals": "Autopůjčovny",
    "compare.disclaimer": "Orientační ceny dle veřejných nabídek (2026). Skutečné ceny konkurence se mohou lišit dle výbavy, nájezdu a podmínek.",
    "compare.updated": "Aktualizováno",
    "audience.individuals": "Jednotlivci",
    "audience.entrepreneurs": "Podnikatelé",
    "audience.companies": "Firmy",
    "audience.flexible": "Flexibilní klienti",
    "audience.speed": "Rychlost & jednoduchost",

    // Partnership
    "part.eyebrow": "Spolupráce a partnerství",
    "part.title": "Spolupráce a partnerství",
    "part.q": "Máte vozidla, která chcete efektivně využít?",
    "part.sub": "Nabízíme možnost spolupráce při dlouhodobém pronájmu vozidel.",
    "part.with": "Spolupracujeme s:",
    "partner.bazars": "Autobazary",
    "partner.rentals": "Autopůjčovny",
    "partner.fleet": "Fleetoví partneři",
    "partner.owners": "Majitelé více vozidel",
    "part.text1": "Zajišťujeme klienty, komunikaci i administrativu.",
    "part.text2": "Naším cílem je dlouhodobá a férová spolupráce přinášející stabilní využití vozidel.",
    "part.interestBtn": "Mám zájem o spolupráci",
    "part.formTitle": "Formulář pro partnery",
    "part.company": "Firma / Jméno *",
    "part.companyPlaceholder": "Název firmy nebo vaše jméno",
    "part.count": "Kolik vozidel? *",
    "part.select": "Vyberte...",
    "part.count1": "1-3 vozidla",
    "part.count2": "4-10 vozidel",
    "part.count3": "11-20 vozidel",
    "part.count4": "20+ vozidel",
    "part.types": "Typ vozidel",
    "part.typesPlaceholder": "např. Škoda, VW, SUV...",
    "part.contact": "Kontakt (email nebo telefon) *",
    "part.contactPlaceholder": "vas@email.cz nebo +420...",
    "part.submit": "Odeslat nabídku",
    "part.submitting": "Odesílám...",
    "part.cancel": "Zrušit",
    "part.successTitle": "Děkujeme za zájem!",
    "part.successDesc": "Vaši nabídku partnerství jsme přijali. Ozveme se vám co nejdříve s individuální nabídkou.",
    "part.ok": "Rozumím",
    "part.error": "Něco se pokazilo. Zkuste to prosím znovu.",

    // Contact
    "contact.eyebrow": "Poptávka",
    "contact.title": "Nezávazná poptávka vozidla",
    "contact.sub": "Vyplňte krátký formulář a připravíme vám nabídku podle vašich požadavků.",
    "contact.name": "Jméno a příjmení *",
    "contact.namePlaceholder": "Jan Novák",
    "contact.email": "Email *",
    "contact.emailPlaceholder": "vas@email.cz",
    "contact.phone": "Telefon",
    "contact.phonePlaceholder": "+420 ...",
    "contact.vehicleType": "Typ vozidla",
    "vt.economy": "Ekonomické vozy",
    "vt.family": "Rodinné vozy",
    "vt.suv": "SUV",
    "vt.premium": "Manažerské vozy",
    "vt.other": "Jiné",
    "contact.duration": "Délka pronájmu",
    "contact.requirements": "Vaše požadavky",
    "contact.requirementsPlaceholder": "Popište vaše potřeby...",
    "contact.submit": "Odeslat poptávku",
    "contact.submitting": "Odesílám...",
    "contact.successTitle": "Poptávka odeslána!",
    "contact.successDesc": "Děkujeme za váš zájem. Ozveme se vám co nejdříve s nabídkou vozidel.",
    "contact.successEmail": "Potvrzení jsme vám zaslali na email",
    "contact.ok": "Rozumím",
    "contact.error": "Něco se pokazilo. Zkuste to prosím znovu.",
    "contact.select": "Vyberte...",
    "contact.infoEmail": "Email",
    "contact.infoPhone": "Telefon",
    "contact.infoArea": "Působnost",
    "contact.areaValue": "Celá ČR",
    "contact.infoHours": "Otevírací doba",

    // Footer
    "footer.offer": "Co nabízíme",
    "footer.how": "Jak to funguje",
    "footer.vehicles": "Vozy",
    "footer.partnership": "Partnerství",
    "footer.contact": "Kontakt",
    "common.rights": "Všechna práva vyhrazena.",
    "common.backHome": "← Zpět na hlavní stránku",

    // VOP
    "vop.eyebrow": "VOP",
    "vop.title": "Všeobecné obchodní podmínky",
    "vop.intro": "Tyto obchodní podmínky upravují poskytování služeb dlouhodobého pronájmu vozidel společností EffectDeal.",
    "vop.p1": "EffectDeal poskytuje klientům služby spočívající v zajištění a pronájmu vozidel podle individuálních požadavků klienta.",
    "vop.p2": "Pronájem vozidla je sjednáván individuálně na základě dohody mezi poskytovatelem a klientem.",
    "vop.p3": "Klient je povinen užívat vozidlo v souladu s právními předpisy a pokyny poskytovatele.",
    "vop.p4": "V případě škody, nehody nebo porušení podmínek je klient povinen neprodleně informovat poskytovatele.",
    "vop.p5": "Podmínky kauce, plateb a délky pronájmu jsou sjednávány individuálně.",
    "vop.p6": "Poskytovatel si vyhrazuje právo odmítnout uzavření spolupráce.",

    // GDPR
    "gdpr.eyebrow": "GDPR",
    "gdpr.title": "Ochrana osobních údajů",
    "gdpr.intro": "EffectDeal zpracovává osobní údaje klientů v rozsahu nezbytném pro poskytování služeb.",
    "gdpr.purposeTitle": "Údaje jsou používány pouze za účelem:",
    "gdpr.purpose1": "Komunikace s klientem",
    "gdpr.purpose2": "Zajištění vozidla",
    "gdpr.purpose3": "Plnění smluvních povinností",
    "gdpr.p1": "Osobní údaje nejsou poskytovány třetím stranám bez právního důvodu.",
    "gdpr.rightsLabel": "Vaše práva:",
    "gdpr.rights": "Klient má právo požadovat opravu nebo výmaz svých údajů.",
    "gdpr.contactPre": "V případě dotazů ohledně zpracování osobních údajů nás kontaktujte na",

    // Cookie consent
    "cookie.text": "Používáme cookies k zajištění správného fungování webu a analýze návštěvnosti.",
    "cookie.accept": "Přijmout",
    "cookie.decline": "Odmítnout",
    "cookie.more": "Více informací",

    // Nav extra
    "nav.calculator": "Kalkulačka",
    "nav.faq": "FAQ",
    "nav.blog": "Blog",

    // Price calculator
    "calc.eyebrow": "Cenová kalkulačka",
    "calc.title": "Spočítejte si orientační cenu",
    "calc.subtitle": "Vyberte vůz, délku pronájmu a měsíční nájezd. Výpočet je orientační – konečnou nabídku připravíme na míru.",
    "calc.vehicle": "Vyberte vůz",
    "calc.months": "Délka pronájmu",
    "calc.monthsUnit": "měsíců",
    "calc.monthsUnit234": "měsíce",
    "calc.monthUnit1": "měsíc",
    "calc.km": "Měsíční nájezd (km)",
    "calc.unlimited": "Neomezeně",
    "calc.resultMonthly": "Orientační měsíční platba",
    "calc.resultTotal": "Celkem za období",
    "calc.discountNote": "sleva za delší pronájem",
    "calc.cta": "Mám zájem",
    "calc.whatsapp": "Poslat na WhatsApp",
    "calc.waMessage": "Dobrý den, mám zájem o pronájem vozu",
    "calc.waSuffix": "Můžete mi prosím připravit nezávaznou nabídku?",
    "calc.note": "Orientační výpočet. Konečná cena závisí na konkrétních podmínkách a dostupnosti vozu.",
    "calc.included": "V ceně každého pronájmu:",
    "calc.inc1": "Havarijní pojištění i povinné ručení",
    "calc.inc2": "Dálniční známka",
    "calc.inc3": "Standardní servis a údržba",
    "calc.inc4": "3 500 km měsíčně v ceně",
    "calc.depositLabel": "Kauce (vratná, bez akontace)",
    "calc.extraKm": "Nad 3 500 km: 3 Kč za každý km navíc",

    // FAQ
    "faq.eyebrow": "Časté dotazy",
    "faq.title": "Často kladené otázky",
    "faq.subtitle": "Vše podstatné o kauci, pojištění, kilometrech a podmínkách pronájmu na jednom místě.",
    "faq.q1": "Jak vysoká je kauce?",
    "faq.a1": "Výše kauce se stanovuje individuálně podle vozu a délky pronájmu, obvykle odpovídá přibližně výši jednoho měsíčního nájmu. Je plně vratná – po řádném ukončení pronájmu a vrácení vozu vám ji vracíme.",
    "faq.q2": "Je vozidlo pojištěné?",
    "faq.a2": "Ano, všechna vozidla mají povinné ručení i havarijní pojištění. Spoluúčast nájemce na případné škodě činí 5 %.",
    "faq.q3": "Jaký je limit najetých kilometrů?",
    "faq.a3": "Standardně počítáme s nájezdem přibližně 3 500 km měsíčně, který je v ceně. Vyšší limit i neomezený nájezd lze domluvit individuálně, stejně jako cenu za případné kilometry navíc.",
    "faq.q4": "Co potřebuji k pronájmu?",
    "faq.a4": "Stačí platný občanský průkaz (nebo pas), řidičský průkaz a věk minimálně 21 let. U firem požadujeme údaje o společnosti (IČO, případně DIČ).",
    "faq.q5": "Na jak dlouho si mohu vůz pronajmout?",
    "faq.a5": "Specializujeme se na dlouhodobý pronájem od 1 měsíce výše. Délku přizpůsobíme vašim potřebám – běžně od 1 do 24 měsíců i déle.",
    "faq.q6": "Co všechno je v ceně pronájmu?",
    "faq.a6": "V ceně je samotné vozidlo, pojištění, dálniční známka a standardní servis. Stačí tankovat a jezdit.",

    // Blog teaser
    "blogt.title": "Novinky a tipy z dlouhodobého pronájmu",
    "blogt.text": "Rady k dlouhodobému pronájmu vozidel, srovnání modelů a tipy, jak ušetřit. Přečtěte si náš blog.",
    "blogt.cta": "Přejít na blog",
  },

  en: {
    "nav.home": "Home",
    "nav.offer": "What we offer",
    "nav.how": "How it works",
    "nav.why": "Why us",
    "nav.vehicles": "Vehicles",
    "nav.forWhom": "For whom",
    "nav.partnership": "Partnership",
    "nav.contact": "Inquiry",
    "cta.inquiry": "Non-binding inquiry",

    "hero.subtitle": "Long-term car rental without compromises",
    "hero.line1": "Modern mobility solutions for individuals and businesses.",
    "hero.line2": "Fast approval, fair terms and cars ready for immediate use.",
    "hero.ctaHow": "How it works",

    "offer.eyebrow": "What we offer",
    "offer.title": "What we offer",
    "offer.p1": "We provide long-term car rental with an emphasis on simplicity, speed and an individual approach.",
    "offer.p2": "Our goal is to provide you with a reliable car without unnecessary paperwork and lengthy processes.",

    "how.eyebrow": "How it works",
    "how.title": "How it works",
    "how.step1Title": "Tell us your requirements",
    "how.step1Desc": "Describe your needs",
    "how.step2Title": "We prepare an offer",
    "how.step2Desc": "We select suitable vehicles",
    "how.step3Title": "Choose and drive away",
    "how.step3Desc": "Fast and without paperwork",
    "how.footer1": "No complicated paperwork.",
    "how.footer2": "No unnecessary waiting.",

    "why.eyebrow": "Why EffectDeal",
    "why.title": "Why choose EffectDeal",
    "why.individual": "Individual approach",
    "why.fast": "Fast processing",
    "why.wide": "Wide range of vehicles",
    "why.flexible": "Flexible terms",
    "why.prices": "Great prices",

    "vehicles.eyebrow": "Our vehicles",
    "vehicles.title": "Our vehicles",
    "vehicles.subtitle": "Choose a specific car. Hover over the thumbnails to view it from every angle, click to see the full equipment and details.",
    "vehicles.footer": "All vehicles are regularly serviced and ready for immediate use.",
    "vehicles.included": "incl. insurance, servicing and CZ vignette · 3,500 km/month · no hidden fees",
    "vehicles.termLabel": "Rental length",
    "vehicles.termHint": "The longer, the better – 2% off from 6 months, 5% off from 12 months.",
    "vehicles.month1": "1 month",
    "vehicles.monthsN": "months",
    "vehicles.atTerm": "for",
    "vehicles.seats": "seats",
    "vehicles.googleTrust": "5.0 on Google · 14 reviews",
    "detail.allPhotos": "All photos",
    "detail.photoOf": "of",
    "detail.specSeats": "Seats",
    "detail.specPower": "Power",
    "detail.specTrim": "Trim",
    "detail.includedTitle": "Included in the price",
    "detail.inc1": "Full insurance and liability cover",
    "detail.inc2": "Servicing, maintenance and seasonal tyres",
    "detail.inc3": "Czech motorway vignette",
    "detail.inc4": "3,500 km per month · no hidden fees",
    "detail.noDeposit": "Refundable deposit 10,000 CZK · no long commitment · from 1 month",
    "compare.subtitle": "A fair comparison: price next to model year, power, mileage and trim – so you know what you get for your money.",
    "compare.tabRentals": "Rental companies",
    "compare.tabLeases": "Operating lease",
    "compare.rowPrice": "Price / month",
    "compare.rowYear": "Model year",
    "compare.rowPower": "Power",
    "compare.rowMileage": "Mileage",
    "compare.rowTrim": "Trim / engine",
    "compare.rowTerm": "Commitment",
    "compare.rowDeposit": "Down payment / deposit",
    "compare.rowKm": "Km included",
    "compare.rowDiff": "Difference vs. us",
    "compare.ours": "Our car",
    "compare.noTerm": "none",
    "compare.noDeposit": "refundable deposit 10,000 CZK",
    "compare.kmOurs": "3,500 km/month",
    "compare.avg": "rental average",
    "compare.saveAvg": "Compared to the rental average you save",
    "compare.pricier": "We are",
    "compare.pricierTail": "above the average – for a newer, more powerful and better-equipped car with no commitment or down payment.",
    "compare.leaseHint": "Leasing looks cheaper, but ties you in for 36–48 months with a down payment and excess-km penalties. With us you stop whenever you want.",
    "compare.unknown": "—",
    "compare.whyTitle": "What you get for the price – the difference in each offer",
    "compare.whyOlder": "older model year",
    "compare.whyNewer": "newer model year",
    "compare.whyWeaker": "weaker engine",
    "compare.whyStronger": "stronger engine",
    "compare.whyTrim": "different trim",
    "compare.whyTerm": "commitment",
    "compare.whyDeposit": "down payment",
    "compare.whyKm": "fewer km included",
    "compare.whyCheaper": "cheaper by",
    "compare.whyPricier": "pricier by",
    "compare.whySame": "same price",
    "compare.whyNoDiff": "comparable offer",
    "compare.whyOurs": "with us",
    "why.p": "Long-term rental without the paperwork. Pick a car, sign online and drive – insurance, servicing and the vignette are included.",
    "why.forTitle": "Who it's for",
    "why.for": "Individuals · freelancers · companies and fleets · anyone who wants a car now, without commitment",
    "vehicles.inStock": "Multiple units in stock",
    "vehicles.detail": "Detail",
    "vehicles.monthly": "Monthly payment",
    "vehicles.showDetail": "View detail",
    "vehicles.filterLabel": "Filter by type",
    "vehicles.filterAll": "All",
    "vehicles.available": "Available now",
    "vehicles.onRequest": "On request",
    "vehicles.noResults": "No vehicles match the selected filter.",
    "vehicles.filterAvailable": "Available now",
    "vehicles.sortLabel": "Sort",
    "vehicles.sortDefault": "Recommended",
    "vehicles.sortPriceAsc": "Price: low to high",
    "vehicles.sortPriceDesc": "Price: high to low",
    "sticky.inquiry": "Free inquiry",
    "price.from": "from",
    "price.perMonth": "/ month",
    "price.onRequest": "Price on request",

    "detail.back": "Back to vehicles",
    "detail.similarTitle": "Similar cars",
    "detail.similarAll": "View all cars",
    "detail.inStockModel": "We have multiple units of this model in stock",
    "detail.monthly": "Monthly payment",
    "detail.specYear": "Year",
    "detail.specTransmission": "Transmission",
    "detail.specFuel": "Fuel",
    "detail.specMileage": "Mileage",
    "detail.inquiryBtn": "I'm interested in this car",
    "detail.call": "Call",
    "detail.equipment": "Vehicle equipment",
    "detail.interestedPre": "Interested in the",
    "detail.interestedDesc": "Get in touch and we'll prepare a tailor-made non-binding offer for you.",
    "detail.bottomCta": "Non-binding inquiry",
    "detail.notFoundTitle": "Vehicle not found",
    "detail.notFoundDesc": "This vehicle is no longer available or the link is invalid.",

    "modal.name": "Full name *",
    "modal.email": "E-mail *",
    "modal.phone": "Phone *",
    "modal.duration": "Preferred rental length",
    "modal.durationPlaceholder": "Select length…",
    "modal.message": "Message (optional)",
    "modal.messagePlaceholder": "Do you have a question or a specific wish?",
    "modal.submit": "Send inquiry",
    "modal.submitting": "Sending…",
    "modal.note": "We'll reply by e-mail as soon as possible",
    "modal.successTitle": "Inquiry sent!",
    "modal.successPre": "Thank you for your interest in the",
    "modal.successPost": "We'll get back to you as soon as possible.",
    "modal.ok": "Got it",
    "modal.error": "Something went wrong. Please try again.",
    "dur.1-3": "1–3 months",
    "dur.3-6": "3–6 months",
    "dur.6-12": "6–12 months",
    "dur.12+": "12+ months",

    "forWhom.eyebrow": "Our clients",
    "promo.badge": "SALE",
    "promo.originalPrice": "Regular price",
    "compare.title": "Market comparison",
    "compare.rental": "Typical rental company",
    "compare.lease": "Operating lease",
    "compare.leaseNote": "36–48 month commitment",
    "compare.usNote": "no long-term commitment",
    "compare.save": "You save up to",
    "compare.mo": "CZK/mo",
    "compare.showAll": "Compare with competitors",
    "compare.hide": "Hide comparison",
    "compare.rentals": "Rental companies",
    "compare.disclaimer": "Indicative prices based on public offers (2026). Actual competitor prices may vary by trim, mileage and terms.",
    "compare.updated": "Updated",
    "forWhom.title": "Who is it for",
    "audience.individuals": "Individuals",
    "audience.entrepreneurs": "Entrepreneurs",
    "audience.companies": "Companies",
    "audience.flexible": "Flexible clients",
    "audience.speed": "Speed & simplicity",

    "part.eyebrow": "Cooperation and partnership",
    "part.title": "Cooperation and partnership",
    "part.q": "Do you have vehicles you want to use efficiently?",
    "part.sub": "We offer cooperation in long-term vehicle rental.",
    "part.with": "We cooperate with:",
    "partner.bazars": "Car dealerships",
    "partner.rentals": "Car rentals",
    "partner.fleet": "Fleet partners",
    "partner.owners": "Owners of multiple vehicles",
    "part.text1": "We handle clients, communication and administration.",
    "part.text2": "Our goal is a long-term and fair cooperation bringing stable use of vehicles.",
    "part.interestBtn": "I'm interested in cooperation",
    "part.formTitle": "Partner form",
    "part.company": "Company / Name *",
    "part.companyPlaceholder": "Company name or your name",
    "part.count": "How many vehicles? *",
    "part.select": "Select...",
    "part.count1": "1-3 vehicles",
    "part.count2": "4-10 vehicles",
    "part.count3": "11-20 vehicles",
    "part.count4": "20+ vehicles",
    "part.types": "Vehicle type",
    "part.typesPlaceholder": "e.g. Škoda, VW, SUV...",
    "part.contact": "Contact (email or phone) *",
    "part.contactPlaceholder": "your@email.com or +420...",
    "part.submit": "Send offer",
    "part.submitting": "Sending...",
    "part.cancel": "Cancel",
    "part.successTitle": "Thank you for your interest!",
    "part.successDesc": "We have received your partnership offer. We'll get back to you soon with an individual offer.",
    "part.ok": "Got it",
    "part.error": "Something went wrong. Please try again.",

    "contact.eyebrow": "Inquiry",
    "contact.title": "Non-binding vehicle inquiry",
    "contact.sub": "Fill in the short form and we'll prepare an offer based on your requirements.",
    "contact.name": "Full name *",
    "contact.namePlaceholder": "John Smith",
    "contact.email": "Email *",
    "contact.emailPlaceholder": "your@email.com",
    "contact.phone": "Phone",
    "contact.phonePlaceholder": "+420 ...",
    "contact.vehicleType": "Vehicle type",
    "vt.economy": "Economy cars",
    "vt.family": "Family cars",
    "vt.suv": "SUV",
    "vt.premium": "Executive cars",
    "vt.other": "Other",
    "contact.duration": "Rental length",
    "contact.requirements": "Your requirements",
    "contact.requirementsPlaceholder": "Describe your needs...",
    "contact.submit": "Send inquiry",
    "contact.submitting": "Sending...",
    "contact.successTitle": "Inquiry sent!",
    "contact.successDesc": "Thank you for your interest. We'll get back to you soon with a vehicle offer.",
    "contact.successEmail": "We've sent a confirmation to your email",
    "contact.ok": "Got it",
    "contact.error": "Something went wrong. Please try again.",
    "contact.select": "Select...",
    "contact.infoEmail": "Email",
    "contact.infoPhone": "Phone",
    "contact.infoArea": "Service area",
    "contact.areaValue": "Whole Czech Republic",
    "contact.infoHours": "Opening hours",

    "footer.offer": "What we offer",
    "footer.how": "How it works",
    "footer.vehicles": "Vehicles",
    "footer.partnership": "Partnership",
    "footer.contact": "Contact",
    "common.rights": "All rights reserved.",
    "common.backHome": "← Back to home page",

    "vop.eyebrow": "Terms",
    "vop.title": "General Terms and Conditions",
    "vop.intro": "These terms and conditions govern the provision of long-term vehicle rental services by EffectDeal.",
    "vop.p1": "EffectDeal provides clients with services consisting of sourcing and renting vehicles according to the client's individual requirements.",
    "vop.p2": "Vehicle rental is arranged individually based on an agreement between the provider and the client.",
    "vop.p3": "The client is obliged to use the vehicle in accordance with legal regulations and the provider's instructions.",
    "vop.p4": "In the event of damage, an accident or a breach of conditions, the client is obliged to inform the provider immediately.",
    "vop.p5": "The terms of the deposit, payments and rental length are arranged individually.",
    "vop.p6": "The provider reserves the right to refuse to enter into cooperation.",

    "gdpr.eyebrow": "GDPR",
    "gdpr.title": "Personal data protection",
    "gdpr.intro": "EffectDeal processes clients' personal data to the extent necessary to provide its services.",
    "gdpr.purposeTitle": "Data is used only for the purpose of:",
    "gdpr.purpose1": "Communication with the client",
    "gdpr.purpose2": "Sourcing the vehicle",
    "gdpr.purpose3": "Fulfilling contractual obligations",
    "gdpr.p1": "Personal data is not provided to third parties without a legal reason.",
    "gdpr.rightsLabel": "Your rights:",
    "gdpr.rights": "The client has the right to request correction or deletion of their data.",
    "gdpr.contactPre": "If you have any questions regarding the processing of personal data, contact us at",

    "cookie.text": "We use cookies to ensure the website works properly and to analyze traffic.",
    "cookie.accept": "Accept",
    "cookie.decline": "Decline",
    "cookie.more": "More information",

    // Nav extra
    "nav.calculator": "Calculator",
    "nav.faq": "FAQ",
    "nav.blog": "Blog",

    // Price calculator
    "calc.eyebrow": "Price calculator",
    "calc.title": "Calculate an estimated price",
    "calc.subtitle": "Choose a car, rental length and monthly mileage. The result is indicative — we'll prepare a tailor-made final offer.",
    "calc.vehicle": "Choose a car",
    "calc.months": "Rental length",
    "calc.monthsUnit": "months",
    "calc.monthsUnit234": "months",
    "calc.monthUnit1": "month",
    "calc.km": "Monthly mileage (km)",
    "calc.unlimited": "Unlimited",
    "calc.resultMonthly": "Estimated monthly payment",
    "calc.resultTotal": "Total for the period",
    "calc.discountNote": "long-term discount",
    "calc.cta": "I'm interested",
    "calc.whatsapp": "Send via WhatsApp",
    "calc.waMessage": "Hello, I'm interested in renting the car",
    "calc.waSuffix": "Could you please prepare a non-binding offer?",
    "calc.note": "Indicative calculation. The final price depends on the specific terms and vehicle availability.",
    "calc.included": "Included in every rental:",
    "calc.inc1": "Comprehensive + third-party liability insurance",
    "calc.inc2": "Highway vignette",
    "calc.inc3": "Standard servicing and maintenance",
    "calc.inc4": "3,500 km per month included",
    "calc.depositLabel": "Deposit (refundable, no down payment)",
    "calc.extraKm": "Above 3,500 km: CZK 3 per extra km",

    // FAQ
    "faq.eyebrow": "FAQ",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Everything important about the deposit, insurance, mileage and rental terms in one place.",
    "faq.q1": "How high is the deposit?",
    "faq.a1": "The deposit is set individually based on the car and rental length and usually corresponds to roughly one monthly rent. It is fully refundable and returned to you after the rental ends and the car is handed back.",
    "faq.q2": "Is the vehicle insured?",
    "faq.a2": "Yes, all vehicles have third-party liability and comprehensive insurance. The renter's deductible on any damage is 5%.",
    "faq.q3": "What is the mileage limit?",
    "faq.a3": "We typically count on around 3,500 km per month, included in the price. A higher limit or unlimited mileage can be arranged individually, as can the price for any extra kilometers.",
    "faq.q4": "What do I need to rent?",
    "faq.a4": "A valid ID card (or passport), a driving license and a minimum age of 21. For companies we require company details (registration number, VAT number if applicable).",
    "faq.q5": "How long can I rent the car for?",
    "faq.a5": "We specialize in long-term rentals from 1 month upwards. We adapt the length to your needs — usually from 1 to 24 months or longer.",
    "faq.q6": "What is included in the rental price?",
    "faq.a6": "The price includes the vehicle itself, insurance, the highway vignette and standard servicing. Just fuel up and drive.",

    // Blog teaser
    "blogt.title": "News and tips on long-term rental",
    "blogt.text": "Advice on long-term car rental, model comparisons and tips on how to save. Read our blog.",
    "blogt.cta": "Go to the blog",
  },

  de: {
    "nav.home": "Startseite",
    "nav.offer": "Angebot",
    "nav.how": "So funktioniert's",
    "nav.why": "Warum wir",
    "nav.vehicles": "Fahrzeuge",
    "nav.forWhom": "Für wen",
    "nav.partnership": "Partnerschaft",
    "nav.contact": "Anfrage",
    "cta.inquiry": "Unverbindliche Anfrage",

    "hero.subtitle": "Langzeitmiete von Fahrzeugen ohne Kompromisse",
    "hero.line1": "Moderne Mobilitätslösungen für Privatpersonen und Unternehmen.",
    "hero.line2": "Schnelle Genehmigung, faire Bedingungen und sofort einsatzbereite Fahrzeuge.",
    "hero.ctaHow": "So funktioniert's",

    "offer.eyebrow": "Angebot",
    "offer.title": "Was wir bieten",
    "offer.p1": "Wir bieten Langzeitmiete von Fahrzeugen mit Fokus auf Einfachheit, Schnelligkeit und individuellen Ansatz.",
    "offer.p2": "Unser Ziel ist es, Ihnen ein zuverlässiges Fahrzeug ohne unnötigen Papierkram und langwierige Prozesse bereitzustellen.",

    "how.eyebrow": "So funktioniert's",
    "how.title": "So funktioniert's",
    "how.step1Title": "Teilen Sie uns Ihre Anforderungen mit",
    "how.step1Desc": "Beschreiben Sie uns Ihre Bedürfnisse",
    "how.step2Title": "Wir erstellen ein Angebot",
    "how.step2Desc": "Wir wählen passende Fahrzeuge aus",
    "how.step3Title": "Auswählen und losfahren",
    "how.step3Desc": "Schnell und ohne Papierkram",
    "how.footer1": "Ohne komplizierten Papierkram.",
    "how.footer2": "Ohne unnötiges Warten.",

    "why.eyebrow": "Warum EffectDeal",
    "why.title": "Warum gerade EffectDeal",
    "why.individual": "Individueller Ansatz",
    "why.fast": "Schnelle Abwicklung",
    "why.wide": "Große Fahrzeugauswahl",
    "why.flexible": "Flexible Bedingungen",
    "why.prices": "Günstige Preise",

    "vehicles.eyebrow": "Unsere Fahrzeuge",
    "vehicles.title": "Unsere Fahrzeuge",
    "vehicles.subtitle": "Wählen Sie ein konkretes Fahrzeug. Fahren Sie über die Vorschaubilder, um das Auto von allen Seiten zu sehen, klicken Sie für die komplette Ausstattung und Details.",
    "vehicles.footer": "Alle Fahrzeuge werden regelmäßig gewartet und sind sofort einsatzbereit.",
    "vehicles.included": "inkl. Versicherung, Service und CZ-Vignette · 3.500 km/Monat · keine versteckten Gebühren",
    "vehicles.termLabel": "Mietdauer",
    "vehicles.termHint": "Je länger, desto günstiger – ab 6 Monaten 2 %, ab 12 Monaten 5 % Rabatt.",
    "vehicles.month1": "1 Monat",
    "vehicles.monthsN": "Monate",
    "vehicles.atTerm": "bei",
    "vehicles.seats": "Sitze",
    "vehicles.googleTrust": "5,0 bei Google · 14 Bewertungen",
    "detail.allPhotos": "Alle Fotos",
    "detail.photoOf": "von",
    "detail.specSeats": "Sitzplätze",
    "detail.specPower": "Leistung",
    "detail.specTrim": "Ausstattung",
    "detail.includedTitle": "Im Preis enthalten",
    "detail.inc1": "Vollkasko und Haftpflicht",
    "detail.inc2": "Service, Wartung und Saisonreifen",
    "detail.inc3": "Tschechische Autobahnvignette",
    "detail.inc4": "3.500 km pro Monat · keine versteckten Gebühren",
    "detail.noDeposit": "Rückzahlbare Kaution 10.000 CZK · keine lange Bindung · ab 1 Monat",
    "compare.subtitle": "Fairer Vergleich: Preis neben Baujahr, Leistung, Laufleistung und Ausstattung – damit Sie wissen, was Sie bekommen.",
    "compare.tabRentals": "Autovermietungen",
    "compare.tabLeases": "Operatives Leasing",
    "compare.rowPrice": "Preis / Monat",
    "compare.rowYear": "Baujahr",
    "compare.rowPower": "Leistung",
    "compare.rowMileage": "Laufleistung",
    "compare.rowTrim": "Ausstattung / Motor",
    "compare.rowTerm": "Bindung",
    "compare.rowDeposit": "Anzahlung / Kaution",
    "compare.rowKm": "Inklusiv-km",
    "compare.rowDiff": "Differenz zu uns",
    "compare.ours": "Unser Fahrzeug",
    "compare.noTerm": "keine",
    "compare.noDeposit": "rückzahlbare Kaution 10.000 CZK",
    "compare.kmOurs": "3.500 km/Monat",
    "compare.avg": "Durchschnitt Vermietungen",
    "compare.saveAvg": "Gegenüber dem Durchschnitt sparen Sie",
    "compare.pricier": "Wir liegen",
    "compare.pricierTail": "über dem Durchschnitt – für ein neueres, stärkeres und besser ausgestattetes Fahrzeug ohne Bindung und Anzahlung.",
    "compare.leaseHint": "Leasing wirkt günstiger, bindet Sie aber 36–48 Monate mit Anzahlung und Mehrkilometer-Strafen. Bei uns hören Sie auf, wann Sie wollen.",
    "compare.unknown": "—",
    "compare.whyTitle": "Was Sie für den Preis bekommen – der Unterschied je Angebot",
    "compare.whyOlder": "älteres Baujahr",
    "compare.whyNewer": "neueres Baujahr",
    "compare.whyWeaker": "schwächerer Motor",
    "compare.whyStronger": "stärkerer Motor",
    "compare.whyTrim": "andere Ausstattung",
    "compare.whyTerm": "Bindung",
    "compare.whyDeposit": "Anzahlung",
    "compare.whyKm": "weniger Inklusiv-km",
    "compare.whyCheaper": "günstiger um",
    "compare.whyPricier": "teurer um",
    "compare.whySame": "gleicher Preis",
    "compare.whyNoDiff": "vergleichbares Angebot",
    "compare.whyOurs": "bei uns",
    "why.p": "Langzeitmiete ohne Papierkram. Auto wählen, online unterschreiben, losfahren – Versicherung, Service und Vignette inklusive.",
    "why.forTitle": "Für wen",
    "why.for": "Privatpersonen · Selbstständige · Firmen und Flotten · alle, die sofort und ohne Bindung ein Auto wollen",
    "vehicles.inStock": "Mehrere Stück auf Lager",
    "vehicles.detail": "Detail",
    "vehicles.monthly": "Monatliche Rate",
    "vehicles.showDetail": "Detail ansehen",
    "vehicles.filterLabel": "Nach Typ filtern",
    "vehicles.filterAll": "Alle",
    "vehicles.available": "Sofort verfügbar",
    "vehicles.onRequest": "Auf Anfrage",
    "vehicles.noResults": "Keine Fahrzeuge entsprechen dem gewählten Filter.",
    "vehicles.filterAvailable": "Sofort verfügbar",
    "vehicles.sortLabel": "Sortieren",
    "vehicles.sortDefault": "Empfohlen",
    "vehicles.sortPriceAsc": "Preis: aufsteigend",
    "vehicles.sortPriceDesc": "Preis: absteigend",
    "sticky.inquiry": "Anfrage senden",
    "price.from": "ab",
    "price.perMonth": "/ Monat",
    "price.onRequest": "Preis auf Anfrage",

    "detail.back": "Zurück zu den Fahrzeugen",
    "detail.similarTitle": "Ähnliche Fahrzeuge",
    "detail.similarAll": "Alle Fahrzeuge anzeigen",
    "detail.inStockModel": "Dieses Modell haben wir in mehreren Stück auf Lager",
    "detail.monthly": "Monatliche Rate",
    "detail.specYear": "Baujahr",
    "detail.specTransmission": "Getriebe",
    "detail.specFuel": "Kraftstoff",
    "detail.specMileage": "Kilometerstand",
    "detail.inquiryBtn": "Ich interessiere mich für dieses Fahrzeug",
    "detail.call": "Anrufen",
    "detail.equipment": "Fahrzeugausstattung",
    "detail.interestedPre": "Interesse am",
    "detail.interestedDesc": "Melden Sie sich und wir erstellen Ihnen ein maßgeschneidertes, unverbindliches Angebot.",
    "detail.bottomCta": "Unverbindliche Anfrage",
    "detail.notFoundTitle": "Fahrzeug nicht gefunden",
    "detail.notFoundDesc": "Dieses Fahrzeug ist nicht mehr verfügbar oder der Link ist ungültig.",

    "modal.name": "Vor- und Nachname *",
    "modal.email": "E-Mail *",
    "modal.phone": "Telefon *",
    "modal.duration": "Bevorzugte Mietdauer",
    "modal.durationPlaceholder": "Dauer wählen…",
    "modal.message": "Nachricht (optional)",
    "modal.messagePlaceholder": "Haben Sie eine Frage oder einen besonderen Wunsch?",
    "modal.submit": "Anfrage senden",
    "modal.submitting": "Senden…",
    "modal.note": "Wir antworten Ihnen so schnell wie möglich per E-Mail",
    "modal.successTitle": "Anfrage gesendet!",
    "modal.successPre": "Vielen Dank für Ihr Interesse am",
    "modal.successPost": "Wir melden uns so schnell wie möglich bei Ihnen.",
    "modal.ok": "Verstanden",
    "modal.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "dur.1-3": "1–3 Monate",
    "dur.3-6": "3–6 Monate",
    "dur.6-12": "6–12 Monate",
    "dur.12+": "12+ Monate",

    "forWhom.eyebrow": "Unsere Kunden",
    "promo.badge": "AKTION",
    "promo.originalPrice": "Regulärer Preis",
    "compare.title": "Marktvergleich",
    "compare.rental": "Übliche Autovermietung",
    "compare.lease": "Operatives Leasing",
    "compare.leaseNote": "36–48 Monate Bindung",
    "compare.usNote": "ohne lange Bindung",
    "compare.save": "Sie sparen bis zu",
    "compare.mo": "CZK/Mon.",
    "compare.showAll": "Mit Wettbewerbern vergleichen",
    "compare.hide": "Vergleich ausblenden",
    "compare.rentals": "Autovermietungen",
    "compare.disclaimer": "Richtpreise basierend auf öffentlichen Angeboten (2026). Tatsächliche Preise können je nach Ausstattung und Konditionen abweichen.",
    "compare.updated": "Aktualisiert",
    "forWhom.title": "Für wen ist der Service",
    "audience.individuals": "Privatpersonen",
    "audience.entrepreneurs": "Selbstständige",
    "audience.companies": "Unternehmen",
    "audience.flexible": "Flexible Kunden",
    "audience.speed": "Schnelligkeit & Einfachheit",

    "part.eyebrow": "Zusammenarbeit und Partnerschaft",
    "part.title": "Zusammenarbeit und Partnerschaft",
    "part.q": "Haben Sie Fahrzeuge, die Sie effizient nutzen möchten?",
    "part.sub": "Wir bieten eine Zusammenarbeit bei der Langzeitvermietung von Fahrzeugen an.",
    "part.with": "Wir arbeiten zusammen mit:",
    "partner.bazars": "Autohäuser",
    "partner.rentals": "Autovermietungen",
    "partner.fleet": "Flottenpartner",
    "partner.owners": "Besitzer mehrerer Fahrzeuge",
    "part.text1": "Wir kümmern uns um Kunden, Kommunikation und Verwaltung.",
    "part.text2": "Unser Ziel ist eine langfristige und faire Zusammenarbeit mit stabiler Fahrzeugnutzung.",
    "part.interestBtn": "Ich interessiere mich für eine Zusammenarbeit",
    "part.formTitle": "Partnerformular",
    "part.company": "Firma / Name *",
    "part.companyPlaceholder": "Firmenname oder Ihr Name",
    "part.count": "Wie viele Fahrzeuge? *",
    "part.select": "Wählen...",
    "part.count1": "1-3 Fahrzeuge",
    "part.count2": "4-10 Fahrzeuge",
    "part.count3": "11-20 Fahrzeuge",
    "part.count4": "20+ Fahrzeuge",
    "part.types": "Fahrzeugtyp",
    "part.typesPlaceholder": "z. B. Škoda, VW, SUV...",
    "part.contact": "Kontakt (E-Mail oder Telefon) *",
    "part.contactPlaceholder": "ihre@email.de oder +420...",
    "part.submit": "Angebot senden",
    "part.submitting": "Senden...",
    "part.cancel": "Abbrechen",
    "part.successTitle": "Vielen Dank für Ihr Interesse!",
    "part.successDesc": "Wir haben Ihr Partnerschaftsangebot erhalten. Wir melden uns bald mit einem individuellen Angebot.",
    "part.ok": "Verstanden",
    "part.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",

    "contact.eyebrow": "Anfrage",
    "contact.title": "Unverbindliche Fahrzeuganfrage",
    "contact.sub": "Füllen Sie das kurze Formular aus und wir erstellen Ihnen ein Angebot nach Ihren Anforderungen.",
    "contact.name": "Vor- und Nachname *",
    "contact.namePlaceholder": "Max Mustermann",
    "contact.email": "E-Mail *",
    "contact.emailPlaceholder": "ihre@email.de",
    "contact.phone": "Telefon",
    "contact.phonePlaceholder": "+420 ...",
    "contact.vehicleType": "Fahrzeugtyp",
    "vt.economy": "Economy-Fahrzeuge",
    "vt.family": "Familienfahrzeuge",
    "vt.suv": "SUV",
    "vt.premium": "Manager-Fahrzeuge",
    "vt.other": "Andere",
    "contact.duration": "Mietdauer",
    "contact.requirements": "Ihre Anforderungen",
    "contact.requirementsPlaceholder": "Beschreiben Sie Ihre Bedürfnisse...",
    "contact.submit": "Anfrage senden",
    "contact.submitting": "Senden...",
    "contact.successTitle": "Anfrage gesendet!",
    "contact.successDesc": "Vielen Dank für Ihr Interesse. Wir melden uns bald mit einem Fahrzeugangebot.",
    "contact.successEmail": "Wir haben eine Bestätigung an Ihre E-Mail gesendet",
    "contact.ok": "Verstanden",
    "contact.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "contact.select": "Wählen...",
    "contact.infoEmail": "E-Mail",
    "contact.infoPhone": "Telefon",
    "contact.infoArea": "Einsatzgebiet",
    "contact.areaValue": "Ganze Tschechische Republik",
    "contact.infoHours": "Öffnungszeiten",

    "footer.offer": "Angebot",
    "footer.how": "So funktioniert's",
    "footer.vehicles": "Fahrzeuge",
    "footer.partnership": "Partnerschaft",
    "footer.contact": "Kontakt",
    "common.rights": "Alle Rechte vorbehalten.",
    "common.backHome": "← Zurück zur Startseite",

    "vop.eyebrow": "AGB",
    "vop.title": "Allgemeine Geschäftsbedingungen",
    "vop.intro": "Diese Geschäftsbedingungen regeln die Erbringung von Langzeit-Fahrzeugvermietungsdiensten durch EffectDeal.",
    "vop.p1": "EffectDeal bietet Kunden Dienstleistungen, die in der Beschaffung und Vermietung von Fahrzeugen nach den individuellen Anforderungen des Kunden bestehen.",
    "vop.p2": "Die Fahrzeugmiete wird individuell auf Basis einer Vereinbarung zwischen Anbieter und Kunde vereinbart.",
    "vop.p3": "Der Kunde ist verpflichtet, das Fahrzeug im Einklang mit den gesetzlichen Vorschriften und den Anweisungen des Anbieters zu nutzen.",
    "vop.p4": "Im Falle eines Schadens, Unfalls oder einer Verletzung der Bedingungen ist der Kunde verpflichtet, den Anbieter unverzüglich zu informieren.",
    "vop.p5": "Die Bedingungen für Kaution, Zahlungen und Mietdauer werden individuell vereinbart.",
    "vop.p6": "Der Anbieter behält sich das Recht vor, eine Zusammenarbeit abzulehnen.",

    "gdpr.eyebrow": "DSGVO",
    "gdpr.title": "Schutz personenbezogener Daten",
    "gdpr.intro": "EffectDeal verarbeitet personenbezogene Daten der Kunden im für die Erbringung der Dienstleistungen erforderlichen Umfang.",
    "gdpr.purposeTitle": "Die Daten werden nur zu folgenden Zwecken verwendet:",
    "gdpr.purpose1": "Kommunikation mit dem Kunden",
    "gdpr.purpose2": "Beschaffung des Fahrzeugs",
    "gdpr.purpose3": "Erfüllung vertraglicher Pflichten",
    "gdpr.p1": "Personenbezogene Daten werden ohne rechtlichen Grund nicht an Dritte weitergegeben.",
    "gdpr.rightsLabel": "Ihre Rechte:",
    "gdpr.rights": "Der Kunde hat das Recht, die Berichtigung oder Löschung seiner Daten zu verlangen.",
    "gdpr.contactPre": "Bei Fragen zur Verarbeitung personenbezogener Daten kontaktieren Sie uns unter",

    "cookie.text": "Wir verwenden Cookies, um die ordnungsgemäße Funktion der Website sicherzustellen und den Verkehr zu analysieren.",
    "cookie.accept": "Akzeptieren",
    "cookie.decline": "Ablehnen",
    "cookie.more": "Mehr Informationen",

    // Nav extra
    "nav.calculator": "Rechner",
    "nav.faq": "FAQ",
    "nav.blog": "Blog",

    // Price calculator
    "calc.eyebrow": "Preisrechner",
    "calc.title": "Berechnen Sie einen Richtpreis",
    "calc.subtitle": "Wählen Sie Fahrzeug, Mietdauer und monatliche Kilometerleistung. Das Ergebnis ist unverbindlich – das endgültige Angebot erstellen wir maßgeschneidert.",
    "calc.vehicle": "Fahrzeug wählen",
    "calc.months": "Mietdauer",
    "calc.monthsUnit": "Monate",
    "calc.monthsUnit234": "Monate",
    "calc.monthUnit1": "Monat",
    "calc.km": "Monatliche Laufleistung (km)",
    "calc.unlimited": "Unbegrenzt",
    "calc.resultMonthly": "Voraussichtliche monatliche Rate",
    "calc.resultTotal": "Gesamt für den Zeitraum",
    "calc.discountNote": "Langzeitrabatt",
    "calc.cta": "Ich habe Interesse",
    "calc.whatsapp": "Per WhatsApp senden",
    "calc.waMessage": "Guten Tag, ich interessiere mich für die Miete des Fahrzeugs",
    "calc.waSuffix": "Könnten Sie mir bitte ein unverbindliches Angebot erstellen?",
    "calc.note": "Unverbindliche Berechnung. Der Endpreis hängt von den konkreten Bedingungen und der Fahrzeugverfügbarkeit ab.",
    "calc.included": "In jeder Miete enthalten:",
    "calc.inc1": "Vollkasko- und Haftpflichtversicherung",
    "calc.inc2": "Autobahnvignette",
    "calc.inc3": "Standardservice und Wartung",
    "calc.inc4": "3.500 km pro Monat inklusive",
    "calc.depositLabel": "Kaution (rückzahlbar, keine Anzahlung)",
    "calc.extraKm": "Über 3.500 km: 3 CZK pro Mehrkilometer",

    // FAQ
    "faq.eyebrow": "FAQ",
    "faq.title": "Häufig gestellte Fragen",
    "faq.subtitle": "Alles Wichtige zu Kaution, Versicherung, Kilometern und Mietbedingungen an einem Ort.",
    "faq.q1": "Wie hoch ist die Kaution?",
    "faq.a1": "Die Höhe der Kaution wird individuell je nach Fahrzeug und Mietdauer festgelegt und entspricht in der Regel etwa einer Monatsmiete. Sie ist voll rückzahlbar und wird Ihnen nach Beendigung der Miete und Rückgabe des Fahrzeugs zurückerstattet.",
    "faq.q2": "Ist das Fahrzeug versichert?",
    "faq.a2": "Ja, alle Fahrzeuge verfügen über eine Haftpflicht- und Vollkaskoversicherung. Die Selbstbeteiligung des Mieters an etwaigen Schäden beträgt 5 %.",
    "faq.q3": "Wie hoch ist das Kilometerlimit?",
    "faq.a3": "Standardmäßig rechnen wir mit etwa 3.500 km pro Monat, die im Preis enthalten sind. Ein höheres Limit oder unbegrenzte Kilometer können individuell vereinbart werden, ebenso der Preis für eventuelle Mehrkilometer.",
    "faq.q4": "Was benötige ich für die Miete?",
    "faq.a4": "Ein gültiger Personalausweis (oder Reisepass), ein Führerschein und ein Mindestalter von 21 Jahren. Bei Unternehmen benötigen wir Firmendaten (Registrierungsnummer, ggf. USt-IdNr.).",
    "faq.q5": "Für wie lange kann ich das Fahrzeug mieten?",
    "faq.a5": "Wir sind auf Langzeitmiete ab 1 Monat spezialisiert. Die Dauer passen wir Ihren Bedürfnissen an – üblicherweise von 1 bis 24 Monate oder länger.",
    "faq.q6": "Was ist im Mietpreis enthalten?",
    "faq.a6": "Im Preis enthalten sind das Fahrzeug selbst, die Versicherung, die Autobahnvignette und der Standardservice. Einfach tanken und losfahren.",

    // Blog teaser
    "blogt.title": "Neuigkeiten und Tipps zur Langzeitmiete",
    "blogt.text": "Ratgeber zur Langzeitmiete von Fahrzeugen, Modellvergleiche und Spartipps. Lesen Sie unseren Blog.",
    "blogt.cta": "Zum Blog",
  },
};

export const LANGUAGES = [
  { code: "cs", label: "CZ" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];
